import service from '@/store/services/vendors/labourer-skills-service';

const state = {
    list: {},
    labourerSkill: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, labourerSkill) => {
        state.labourerSkill = labourerSkill;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(labourerSkill => {
                commit('SET_RESOURCE', labourerSkill);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(labourerSkill => {
                commit('SET_RESOURCE', labourerSkill);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((labourerSkill) => {
                commit('SET_RESOURCE', labourerSkill);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((labourerSkill) => {
                commit('SET_RESOURCE', labourerSkill);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    labourerSkill: state => state.labourerSkill,
    dropdown: (state) => {
        return state.list.map(labourerSkill => ({
            id: labourerSkill.id,
        }));
    }
};

const labourerSkills = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default labourerSkills;
